export enum PAYMENT_STATUS {
  PAID = 'paid',
  }
export const ENTER_KEY = 'Enter';
const DEFAULT_VENDOR_LOGO = '/images/default-vendor.png';
enum PRODUCT_TAB_KEY {
  Overview,
  Features,
  Alternatives,
  Pricing,
  Manufacturer,
}
const VERIFIED_VENDOR_MESSAGE = 'This vendor is verified by askiot';
export const REQUEST_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

const OTP_LENGTH = 6;
export const MAX_LEAD_EMAILS = 3;
export enum USER_ROLE {
  USER = 'user',
}

export const LIMIT_RESTRICT_LIST_LENGTH = 5;

enum ACTIONS_KEY {
  EDIT,
  DELETE,
  DUPLICATE,
}

const DEFAULT_IMG = '/images/logo/logo.svg';
